<template>
  <div id="app" :class="{ 'auth': $route.path==='/login' || $route.path==='/join' }">
    <Navbar />
    <router-view/>
  </div>
</template>

<script>
import firebase from 'firebase'
import Navbar from '@/components/utility/Navbar'
require('@/assets/css/styles.css')

export default {
  name: 'App',
  components: {
    Navbar
  }
}
</script>

<style>

.auth .navbar { display: none; }

</style>



// WEBPACK FOOTER //
// src/App.vue